import { render, staticRenderFns } from "./SettingsReissueTypes.vue?vue&type=template&id=1b4cda25&scoped=true"
import script from "./SettingsReissueTypes.vue?vue&type=script&lang=js"
export * from "./SettingsReissueTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsReissueTypes.vue?vue&type=style&index=0&id=1b4cda25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cda25",
  null
  
)

export default component.exports